module.exports = __webpack_public_path__ + "static/media/selected_icn_map_event_coda.6e929755.svg";